<template>
  <div class="home">
    <van-nav-bar v-if="page==1" title="隐私政策" left-arrow @click-left="onClickLeft"/>
    <div class="container">
      <h1>中科名兽医隐私政策协议</h1>
      <p>中科名兽医尊重并保护所有使用中科名兽医服务用户的个人隐私权。我们会逐一说明我们对个人信息收集、使用、保护等处理的情况，以便您能够了解个人信息的概况。中科名兽医将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，中科名兽医不会将这些信息对外披露或向第三方提供。中科名兽医会不时更新本隐私权政策。 您在同意中科名兽医网络服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于中科名兽医使用协议不可分割的一部分。</p>
      <h2>1. 适用范围</h2>
      <p>a) 在您注册中科名兽医帐号时，您根据中科名兽医要求提供的个人注册信息（商家应法律法规要求需公示的企业名称及相关工商注册信息除外）；</p>
      <p>b) 在您中科名兽医网络服务，中科名兽医自动接收并记录的您的设备信息，包括但不限于您的IP地址、使用的语言、访问日期和时间、软硬件特征信息及您需求的访问记录等数据；</p>
      <p>c) 中科名兽医通过合法途径从商业伙伴处取得的用户个人数据。</p>
      <p>您了解并同意，以下信息不适用本隐私权政策：</p>
      <p>a) 您在使用中科名兽医平台提供的搜索服务时输入的关键字信息；</p>
      <p>b) 中科名兽医收集到的您在中科名兽医发布的有关信息数据，包括但不限于参与活动、成交信息及评价详情；</p>
      <p>a) 在您注册中科名兽医帐号时，您根据中科名兽医要求提供的个人注册信息（商家应法律法规要求需公示的企业名称及相关工商注册信息除外）；</p>
      <p>c) 违反法律规定或违反中科名兽医规则行为及中科名兽医已对您采取的措施。</p>
      <h2>2. 信息使用</h2>
      <p>a) 中科名兽医不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和中科名兽医（含中科名兽医关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。</p>
      <p>b) 中科名兽医亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何中科名兽医平台用户如从事上述活动，一经发现，中科名兽医有权立即终止与该用户的服务协议。</p>
      <!-- <p>c) 为服务用户的目的，中科名兽医可能通过使用您的个人信息，向您提供您感兴趣的信息，包括但不限于向您发出产品和服务信息，或者与中科名兽医合作伙伴共享信息以便他们向您发送有关其产品和服务的信息（后者需要您的事先同意）。</p> -->
      <h2>3. 信息披露</h2>
      <p>在如下情况下，中科名兽医广将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：</p>
      <p>a) 经您事先同意，向第三方披露；</p>
      <p>b) 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；</p>
      <p>c) 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</p>
      <p>d) 如您出现违反中国有关法律、法规或者中国农技推广服务协议或相关规则的情况，需要向第三方披露；</p>
      <p>e) 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；</p>
      <p>f) 在中科名兽医创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，中科名兽医有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。</p>
      <p>g) 其它中科名兽医根据法律、法规或者网站政策认为合适的披露。</p>
      <h2>4. 信息存储和交换</h2>
      <p>中科名兽医收集的有关您的信息和资料将保存在中科名兽医及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或中科名兽医收集信息和资料所在地的境外并在境外被访问、存储和展示。</p>
      <h2>5. Cookie的使用</h2>
      <p>a) 在您未拒绝接受cookies的情况下，中科名兽医会在您的设备上设定或取用cookies，以便您能登录或使用依赖于cookies的中科名兽医平台服务或功能。<!--中国农技推广使用cookies可为您提供更加周到的个性化服务，包括推广服务。--></p>
      <p>b) 您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的中科名兽医网络服务或功能。</p>
      <p>c) 通过中科名兽医所设cookies所取得的有关信息，将适用本政策。</p>
      <h2>6. 信息安全</h2>
      <p>a) 中科名兽医帐号均有安全保护功能，请妥善保管您的用户名及密码信息。中科名兽医将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“完善的安全措施”。</p>
      <p>b) 在使用中科名兽医网络服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是中国农技推广用户名及密码发生泄露，请您立即联系中科名兽医客服，以便中科名兽医采取相应措施。</p>
      <p>与第三方服务提供商与业务合作伙伴共享</p>
      <p>为保证向您提供本隐私政策目的所述的服务，我们可能会向第三方服务提供商与业务合作伙伴等第三方共享必要的个人信息。</p>
      <p>这包括我们的物流供应商、数据中心、数据存储设施、客户服务供应商、广告和营销服务供应商以及其他业务合作伙伴，比如：华为技术有限公司、小米科技有限责任公司、腾讯、深圳市和讯华谷信息技术有限公司、北京百度网讯科技有限公司、北京锐讯灵通科技有限公司等。这些第三方可能代表中科名兽医 App或出于本隐私政策的一项或多项目的处理您的个人信息。我们保证仅出于正当、合法、必要、特定、明确的目的共享为您提供服务所必要的个人信息。 中科名兽医 App将进行尽职调查并签订合同，以确保第三方服务提供商遵守您所属司法管辖区中适用的隐私法律。第三方服务提供商也可能拥有其子处理者。</p>
      <p>为提供成效衡量、分析和其他商业服务，我们还可能以汇总的形式与第三方（例如向我们的广告商）共享信息（非个人信息）。我们使用所掌握的信息来帮助广告主和其他合作伙伴评估他们广告和服务的成效及覆盖情况，并了解使用他们服务的人群类型以及人们如何与其网站、应用和服务互动。我们也可能与其共享我们服务的一般使用趋势，例如购买某些产品或从事某些交易的特定人群中的客户数量。</p>
      <p>接入第三方服务的情形，我们可能会接入第三方SDK服务，并将我们依照本政策收集的您某些信息共享给该等第三方服务商，以便提高更好的客户服务和用户体验。目前我们产品中包含的第三方SDK服务请查阅。<el-button type="text" size="mini" @click="goSdk">《第三方SDK目录》</el-button></p>
      <p>目前，我们接入的第三方服务商主要包括以下几种类型：</p>
      <p>1. 用于消息推送功能，包括收集网络位置信息、网络类型、手机号码等；</p>
      <p>2. 用于云服务，包括收集网络位置信息、网络类型、手机号码等</p>
      <p>3. 用于推送功能，包括获取设备型号、网络类型、设备存储和设备运行进程信息等；</p>
      <p>4. 用于搜集崩溃信息，包括系统唯一标识符、SIM卡序列号、ANDROID_ID等；</p>
      <p>5. 用于推送功能，包括收集网络位置信息、网络类型、手机号码、SIM卡状态等；</p>
      <p>6. 用于提供浏览器服务，包括收集设备标识信息（IMEI/Mac/android ID/IDFA/OPENUDID/GUID）、mac地址；</p>
      <p>7. 用于提供定位以及地图展示，包括收集外部存储状态、最近一次地理位置信息、持续定位、网络类型、网络服务运营商、IMEI、MAC地址、WiFi信息；</p>
      <p>8. 用于消息分享/统计分析，获取用户设备的(IMEI、IMSI)，通过IMEI对用户进行唯一标识，以便提供服务；通过获取位置信息，为开发者提供反舞弊功能，剔除作弊设备；基于设备提供SDK服务；基于IP提供地区数据报表。友盟可能通过了解一些您的网络使用习惯、您常用的软件信息等手段来判断您账号的风险，并可能会记录一些友盟认为有风险的URL。</p>
      <!-- <p>8. 用于消息分享/统计分析，包括收集设备信息IMEI；获取用户设备的IMEI，通过IMEI对用户进行唯一标识，以便提供服务；友盟可能通过了解一些您的网络使用习惯、您常用的软件信息等手段来判断您账号的风险，并可能会记录一些友盟认为有风险的URL。</p> -->
      <p>我们仅会出于正当、必要、特定的目的共享您的信息。对我们与之共享信息的第三方服务商，我们会要求他们履行相关保密义务并采取相应的安全措施。</p>
      <p>第三方社交媒体或其他服务由相关的第三方负责运营。您使用该等第三方的社交媒体服务或其他服务（包括您向该等第三方提供的任何信息），须受第三方自己的服务条款及信息保护声明（而非本政策）约束，您需要仔细阅读其条款。本政策仅适用于我们所收集的个人信息，并不适用于任何第三方提供的服务或第三方的信息使用规则。如您发现这些第三方社交媒体或其他服务存在风险时，建议您终止相关操作以保护您的合法权益。</p>
      <h2>7. 账号注销说明</h2>
      <p>您可以通过客服或通过其他我们公示的方式申请注销您的账号，当您注销账号后，您将无法在以该账号登录和使用我们的产品与服务；且该账号在中科名兽医及公司旗下的其他产品与服务使用期间已产生的但未消耗完毕的权益及未来等全部利益将被清除；将会自动解绑其他APP和网站授权登录或解绑关系；除法律明确规定必须由我们保留的个人信息外，您的个人信息将会从中科名兽医移除，注销成功后，将无法恢复。</p>
      <p>注销路径为： 您可以通过【我的-账号编辑-注销账号】注销时效为三天内处理完毕。</p>
      <h2>8. 联系我们</h2>
      <p>a) 中科名兽医由北京中科基因技术股份有限公司提供，我们的办公地址是 北京市大兴区生物医药基地永大路38号5号楼,如果您对个人信息保护问题又投诉、建议、疑问，您可以直接将问题发送至（han.xiaoxue@sslab.com.cn），我们核查并验证您的用户身份后会及时反馈您的投诉与举报。</p>
      <p>b) 如您对本隐私政策内容有任何疑问、意见或建议，您可通过客服电话010-62142951或者客服邮箱留言的方式与我们联系。</p>
      <h2>9. 第三方提供商及其服务</h2>
      <p>为确保流畅的浏览体验，您可能会收到来自中科名兽医及其合作伙伴外部的第三方（以下简称「第三方」）提供的内容或网络链接。中科名兽医对此类第三方无 控制权。您可选择是否访问第三方提供的链接、内容、产品和服务。中科名兽医无法控制第三方的隐私和个人信息保护政策，此类第三方不受到本政策的约束。您在向第三方提交个人信息之前，请确保您阅读并认可这些第三方的隐私保护政策。</p>
      <h2>10. 您直接提供和我们自动采集的个人信息</h2>
      <ul>
        <li>注册信息。您使用中科名兽医提供的服务，可以注册并登录经注册的中科名兽医帐号。此时，您需要向我们提供以下信息：手机号码、 真实姓名等。提供上述信息并同意注册协议和本政策后，您可以使用中科名兽医的核心业务功能，包括：浏览中科名兽医平台内的内容、专家咨询、检测下单等</li>
        <li>位置信息。当您开启设备定位功能并使用我们基于位置提供的相关服务时，我们会收集有关您位置的信息。该信息属于 敏感信息，拒绝提供该信息仅会使您无法使用与位置信息相关的功能，但不影响您正常使用中科名兽医的其他功能。</li>
        <li>设备信息。作为游客用户的唯一标识，方便用户查看观看视频历史。此时我们会收集您的以下设备信息：包括设备型号、唯一设备标识符（如 Android ID / DEVICE_ID/SIM的序列号/ UUID）、设备 MAC 地址、电信运营商、操作系统类型、IMSI及型号、SD卡、软件版本号。当您将APP切换至后台时，为了您能够及时获取用户评论、即时通讯等消息，融云SDK，极光推送SDK也会获取您的设备信息。</li>
        <li>访问App安装列表：如您分享，需要访问APP安装列表来判断是否已安装微信/QQ等客户端。</li>
        <li>获取运行中的进程信息：当您进入APP时，我们获取运行中的进程信息来判断当前进程是否为主进程，从而触发执行SDK的初始化。如果您不提供这些信息，我们将无法提供相关服务。</li>
      </ul>
      <!-- <p>a) 中科名兽医由北京中科基因技术股份有限公司提供，如果您对个人信息保护问题又投诉、建议、疑问，您可以直接将问题发送至（han.xiaoxue@sslab.com.cn），我们核查并验证您的用户身份后会及时反馈您的投诉与举报。</p> -->
      <!-- <p>b) 如您对本隐私政策内容有任何疑问、意见或建议，您可通过登录“中科名兽医”客户端的“我的”->“帮助与反馈”->"反馈”入口与我们联系。</p> -->
      <p class="address">生效日期： 2020年8月13日</p>
    </div>
  </div>
</template>

<script>
// import { shopCombination } from '@/api/resetApi.js'

export default {
  name: 'announcement',
  data(){
    return{
      page: '',
      tiem: '',
      timer: '',
      goodsList: [],
    }
  },
  created(){
    this.page = this.$route.query.page
  },
  methods: {
    onClickLeft() {
      // this.$router.back(-1)
      this.$router.replace('/expertlogin')
    },
    goSdk(){
      this.$router.push('/sdk')
    }
  }
}
</script>

<style lang="scss">
.home {
  max-width: 780px;
  margin: 0 auto;
}
.container {
  padding: 20px 10px;
  h1 {
    text-align: center;
    font-size: 16px;
    padding-bottom: 10px;
  }
  h2 {
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    padding-bottom: 5px;
  }
  h3 {
    padding: 5px 0;
    text-align: left;
    font-size: 12px;
    font-weight: bold;
  }
  p, li {
    padding-bottom: 10px;
    text-align: left;
    line-height: 20px;
    font-size: 12px;
    color: #000;
  }
  ul{
    padding-left:20px;
  }
  li{
    list-style: disc;
  }
  strong {
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    color: #000;
  }
  .address-p {
    padding-bottom: 0;
  }
  .address {
    padding: 10px;
    text-align: right;
  }
  .tableclass {
    width: 100%;
    margin-bottom: 10px;
    border-collapse: collapse;
    border: 1px solid #666;
    font-size: 10px;
    color: #000;
    text-align: center;
    thead {
      tr {
        th {
          padding: 5px;
          line-height: 20px;
          border: 1px solid #666;
          vertical-align: middle;
          font-weight: bold;
        }
      }
    }
    tbody {
      tr {
        td {
          padding: 5px;
          line-height: 20px;
          border: 1px solid #666;
          vertical-align: middle;
          a {
            word-wrap: break-word;
            word-break: break-all;
            color: #0186FF;
          }
        }
      }
    }
  }
}
</style>
